import React from "react";
import { BASE_URL } from "../../constants";

const ClientSingle = ({ img_1 }) => {
  return (
    <>
      <div className="brand__item-wrapper">
        <div className="brand__item m-img">
          <img
            src={`${BASE_URL}collaborators/collaborators_${img_1}.jpg`}
            alt="Dsider"
          />
        </div>
      </div>
    </>
  );
};

export default ClientSingle;
